import CommonDetails from "./CommonDetails";

export default CommonDetails;
